import { useCallback } from 'react';
import { useAuthStore } from '@/Stores/auth-v2-store';
import { useUpdateExternalUser } from '@/features/external-users/hooks/useExternalUsers';

/**
 * Hook pour activer/désactiver les tutoriels dans le profil utilisateur.
 * Met à jour le store Zustand (immédiat) + persiste en BDD (async).
 */
export const useToggleTutorials = () => {
  const { currentUser, updateCurrentUser } = useAuthStore();
  const updateUserMutation = useUpdateExternalUser();

  const enableTutorials = useCallback(() => {
    if (!currentUser?.id || currentUser.showTutorials === true) return;
    updateCurrentUser({ showTutorials: true });
    updateUserMutation.mutate({ id: currentUser.id, data: { showTutorials: true } });
  }, [currentUser?.id, currentUser?.showTutorials, updateCurrentUser, updateUserMutation]);

  const disableTutorials = useCallback(() => {
    if (!currentUser?.id || currentUser.showTutorials === false) return;
    updateCurrentUser({ showTutorials: false });
    updateUserMutation.mutate({ id: currentUser.id, data: { showTutorials: false } });
  }, [currentUser?.id, currentUser?.showTutorials, updateCurrentUser, updateUserMutation]);

  return { enableTutorials, disableTutorials };
};
